import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'numberToHours',
})
export class TimeDifferencePipe implements PipeTransform {
  private translator = inject(TranslateService);

  transform(time: string): string {
    const firstDate: Date = new Date(time);

    const secondDate: Date = new Date();

    const milliDiff: number = secondDate.getTime() - firstDate.getTime();

    const days = Math.floor(milliDiff / (24 * 60 * 60 * 1000));

    const hours = Math.floor(milliDiff / (60 * 60 * 1000));

    const minutes = Math.floor(milliDiff / (60 * 1000));

    if (days > 0) {
      return this.translate('days', days);
    } else if (hours > 0) {
      return this.translate('hours', hours);
    } else {
      return this.translate('minutes', minutes);
    }
  }

  translate(unit: string, value: number): string {
    const unitKey = value === 1 ? unit.slice(0, -1) : unit;

    return this.translator.instant(`time_difference.${unitKey}`, { time: value });
  }
}
